import React from 'react'
import Success from '../features/success/Success'

const SuccessPage = () => {
  return (
    <Success />
  )
}

export default SuccessPage